import React from 'react';
import classnames from 'classnames';
import { PapiEditorText } from '@wix/da-types-papi';
import CustomBoxViewer from '@wix/da-shared-react/pkg/DaEditorWrapper/Viewer/CustomBox';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';
import Background, { Props as BackgroundProps } from './Background';
import {
  MeasuredContainer,
  MeasuredCookieType,
  MeasuredInjectedProps,
} from '@wix/da-shared-react/pkg/Measured';
import s from './Custom.scss';

export interface Props extends BackgroundProps {
  title?: string;
  customtext: PapiEditorText;
  moduleId: number;
  moduleVersion: number;
}
const Custom: React.SFC<Props> = (props: Props) => {
  return (
    <Background
      {...props}
      className={classnames('da-editor-custombox', s['root'], props.className)}
    >
      <MeasuredContainer
        cookieType={MeasuredCookieType.USER_PROFILE_CUSTOM}
        cookieDim="width"
        listenOnWindow
      >
        {(measuredProps: MeasuredInjectedProps) => {
          const width =
            (measuredProps.container && measuredProps.container.width) || 600;

          return (
            <div style={{ width: '100%' }} ref={measuredProps.onRef}>
              <TextRenderer
                width={width}
                textContent={props.customtext}
                reactViewer={CustomBoxViewer}
                legacyTheme={'default'}
                viewerKey={`custombox-${props.moduleId}-${props.moduleVersion}`}
              />
            </div>
          );
        }}
      </MeasuredContainer>
    </Background>
  );
};
Custom.displayName = 'Custom';

export default Custom;
